export const sAdd = "Add ";
export const sAddProduct = "Add Product";
export const sAddCategory = "Add Category";
export const sUpdateCategory = "Update Category";
export const sUpdate = "Update ";
export const sAddShop = sAdd + "Shop";
export const sAddRegion = "Add Region";
export const sAddCustomer = "Add Customer";
export const sAddStaff = "Add Staff";
export const sPhonePrefix = "+256";
export const sNotification = "Notification";
export const sNotifications = "notifications";
export const sNew = "New ";
export const sUGX = "UGX";
export const sActive = "Active";
export const sNewOrder = sNew + "Order";
export const sAddSection = sAdd + "Section";
export const sUpdateShop = sUpdate + "Shop";
export const sPending = "Pending";
export const sResolved = "Resolved";

// keys
export const kTimestamp = "timestamp";
export const kSort = "sort";
export const sProducts = "products";
export const sShops = "shops";
export const sCategories = "categories";
export const sUsers = "users";
export const sOrders = "orders";
export const sFeed = "feed";
export const sBanners = "banners";
export const sRegions = "regions";

// statuses

// misc
export const sUnavailable = "Unavailable";
export const VIEW = "View";
export const PAYMENT_METHODS = "Payment Methods";
export const ROLES = "roles";
export const USERS = "users";
export const PERMISSIONS = "permissions";
export const ADMIN = "admin";
export const CONFIGURABLES = "configurables";

// constants
export const SORT = "sort";
